/**
 * FavouriteIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FavouriteIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.994 20.504q-.405 0-.811-.146a2 2 0 0 1-.724-.457l-1.737-1.586a65 65 0 0 1-4.782-4.816Q1.797 11.09 1.797 8.15q0-2.438 1.629-4.073Q5.053 2.44 7.494 2.44q1.313 0 2.482.535 1.17.536 2.018 1.487a6.1 6.1 0 0 1 2.018-1.487 5.9 5.9 0 0 1 2.482-.535q2.442 0 4.079 1.635t1.636 4.074q0 2.94-2.14 5.362a59 59 0 0 1-4.828 4.834l-1.706 1.561c-.205.205-.453.36-.727.454a2.5 2.5 0 0 1-.814.144M11.002 6.78q-.69-.99-1.523-1.527-.834-.537-1.983-.537-1.468 0-2.446.979-.978.978-.978 2.455 0 1.29.916 2.738.915 1.45 2.19 2.812 1.276 1.364 2.625 2.553 1.35 1.19 2.191 1.957 1.088-.993 2.196-1.964a38 38 0 0 0 2.629-2.55 19 19 0 0 0 2.196-2.807q.92-1.445.92-2.74 0-1.474-.983-2.454-.982-.98-2.455-.98-1.155 0-1.985.538t-1.52 1.527a1.2 1.2 0 0 1-.444.402 1.197 1.197 0 0 1-1.546-.402" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FavouriteIcon = makeIcon('FavouriteIcon', FavouriteIconSvg)
